import { useQuery } from "@tanstack/react-query";
import type { ActivityTimelineData } from "@/hooks/api/use-account-activities";
import { api, generateQueryKey } from "@/lib/api";

/**
 * Hook to fetch activity timeline data aggregated across all accounts associated with a person
 * @param personId - The person ID to fetch timeline for
 * @returns Aggregated timeline data, loading state, and error
 */
export function usePersonActivityTimeline(personId?: string) {
  return useQuery<ActivityTimelineData>({
    queryKey: generateQueryKey(
      `datahub/persons/${encodeURIComponent(
        personId || "",
      )}/activity-timeline/`,
    ),
    queryFn: () =>
      api.get<ActivityTimelineData>(
        `datahub/persons/${encodeURIComponent(
          personId || "",
        )}/activity-timeline/`,
      ),
    enabled: !!personId,
  });
}
